// src/App.jsx
import "./CSS/root.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline, Container, Box, Typography } from "@mui/material";

import Header from "./components/pages/Header";
import Footer from "./components/Footer";
import ScrollTopButton from "./components/ScrollTopButton";
import Analytics from "./components/Analytics";

import Home from "./components/pages/home";
import Database from "./components/pages/Database";
import AdminTeam from "./components/pages/AdminTeam/AdminTeam";
import AdminTeamMembers from "./components/pages/AdminTeam/AdminTeamMembers";
import AdminTeamContribution from "./components/pages/AdminTeam/AdminTeamContribution";
import AdminTeamContact from "./components/pages/AdminTeam/AdminTeamContact";

import Unauthorized from "./components/ProtectedRoute/Unauthorized";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import AdminDashboard from "./components/ProtectedRoute/Admin/AdminDashboard";
import { theme } from "./components/ProtectedRoute/Admin/Consoles/Framework/theme";
import { ToastProvider } from "./components/ProtectedRoute/Admin/Consoles/Framework/ToastProvider";
import ResearchersConsole from "./components/ProtectedRoute/Admin/Consoles/Pages/ResearchersConsole";
import InstitutesConsole from "./components/ProtectedRoute/Admin/Consoles/Pages/InstitutesConsole";
import ScientificNamesConsole from "./components/ProtectedRoute/Admin/Consoles/ScientificName/ScientificNamesConsole";
import TaxonomicActsConsole from "./components/ProtectedRoute/Admin/Consoles/Pages/TaxonomicActsConsole";
import BionomicRecordsConsole from "./components/ProtectedRoute/Admin/Consoles/Pages/BionomicRecordsConsole";
import JournalsConsole from "./components/ProtectedRoute/Admin/Consoles/Pages/JournalsConsole";
import CountriesConsole from "./components/ProtectedRoute/Admin/Consoles/Pages/CountriesConsole";
import AdminTeamMessages from "./components/ProtectedRoute/Admin/Consoles/Pages/AdminTeamMessages";
import CommentsConsole from "./components/ProtectedRoute/Admin/Consoles/Pages/CommentsConsole";
import { SupabaseAuthProvider } from "./utils/AuthSessionProvider";
import { MasterDataProvider } from "./utils/MasterDataProvider";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { StatusDialogProvider } from "./components/common/StatusDialogProvider";
import AnalysisHome from "./components/pages/Analysis/AnalysisHome";
import ComparisonWithChecklists from "./components/pages/Analysis/ComparisonWithChecklists";
import ComparisonSyncPage from "./components/ProtectedRoute/Admin/Consoles/Pages/ComparisonSyncPage";
import TaxonomyHome from "./components/pages/Taxonomy/TaxonomyHome";
import TaxonomyExplore from "./components/pages/Taxonomy/TaxonomyExplore";
import CumulativeDescriptionTrends from "./components/pages/Analysis/CumulativeDescriptionTrends";
import AnnualDescriptionTrends from "./components/pages/Analysis/AnnualDescriptionTrends";
import TotalSpeciesEstimation from "./components/pages/Analysis/TotalSpeciesEstimation";
import ScientificNameDetailsPage from "./components/pages/Taxonomy/ScientificNameDetailsPage";
import PublicationsConsole from "./components/ProtectedRoute/Admin/Consoles/Publications/PublicationsConsole";

// 404 シンプル版（必要なければ削除してください）
function NotFound() {
  return (
    <Box sx={{ py: 8, textAlign: "center" }}>
      <Typography variant="h5" gutterBottom>404 Not Found</Typography>
      <Typography variant="body2" color="text.secondary">
        Sorry... We couldn't find the specific page or resource you asked for.
        </Typography>
    </Box>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
        <SupabaseAuthProvider>
          <MasterDataProvider>
            <ToastProvider>
              <StatusDialogProvider>
              <ScrollTopButton />
              <div className="root-container">
                <Header />
                {/* Container 縺ｯ螂ｽ縺ｿ縺ｧ縲よ里蟄呂SS縺梧紛縺｣縺ｦ縺・ｋ縺ｪ繧牙､悶＠縺ｦ繧０K */}
                <Container maxWidth="xl" sx={{ py: 2 }}>
                  <Routes>
                {/* 笏笏 Public pages 笏笏 */}
                <Route path="/" element={<Home />} />
                <Route path="/database" element={<Database />} />
                <Route path="/taxonomy" element={<TaxonomyHome />} />
                <Route path="/taxonomy/taxon-explore" element={<TaxonomyExplore />} />
                <Route path="/analysis" element={<AnalysisHome />} />
                <Route
                  path="/analysis/total-species-estimation"
                  element={<TotalSpeciesEstimation />}
                />
                <Route
                        path="/analysis/comparison-with-checklists"
                        element={<ComparisonWithChecklists />}
                />
                <Route
                  path="/analysis/cumulative-description-trends"
                  element={<CumulativeDescriptionTrends />}
                />
                <Route
                  path="/analysis/annual-description-trends"
                  element={<AnnualDescriptionTrends />}
                />
                <Route path="/admin-team" element={<AdminTeam />} />
                <Route path="/admin-team/members" element={<AdminTeamMembers />} />
                <Route path="/admin-team/member-contribution" element={<AdminTeamContribution />} />
                <Route path="/admin-team/contact" element={<AdminTeamContact />} />
                <Route path="/scientific-name/:id" element={<ScientificNameDetailsPage />} />

                {/* 笏笏 Auth / Guarded 笏笏 */}
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />

                {/* 笏笏 Admin Consoles 笏笏 */}
                {/* Publications 縺ｯ蜈ｱ騾壹ヵ繝ｬ繝ｼ繝螳溯｣・↓鄂ｮ縺肴鋤縺・*/}
                <Route
                  path="/admin/console-publications"
                  element={
                    <ProtectedRoute>
                      <PublicationsConsole />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/console-journals"
                  element={
                    <ProtectedRoute>
                      <JournalsConsole />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/console-researchers"
                  element={
                    <ProtectedRoute>
                      <ResearchersConsole />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/console-scientific-names"
                  element={
                    <ProtectedRoute>
                      <ScientificNamesConsole />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/console-taxonomic-acts"
                  element={
                    <ProtectedRoute>
                      <TaxonomicActsConsole />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/console-bionomics"
                  element={
                    <ProtectedRoute>
                      <BionomicRecordsConsole />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/console-countries"
                  element={
                    <ProtectedRoute>
                      <CountriesConsole />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/console-repositories"
                  element={
                    <ProtectedRoute>
                      <InstitutesConsole />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/console-comments"
                  element={
                    <ProtectedRoute>
                      <CommentsConsole />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/comparison-sync"
                  element={
                    <ProtectedRoute>
                      <ComparisonSyncPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/messages"
                  element={
                    <ProtectedRoute>
                      <AdminTeamMessages />
                    </ProtectedRoute>
                  }
                />
                {/* 404 */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Container>

                <Footer />
                <Analytics />
              </div>
              </StatusDialogProvider>
            </ToastProvider>
          </MasterDataProvider>
        </SupabaseAuthProvider>
      </GoogleReCaptchaProvider>
    </ThemeProvider>
  );
}
